export const onQuery = (q) => ({
  type: 'QUERY',
  q
})

export const onSet = (selected) => ({
  type: 'SET',
  selected
})

export const onToggle = (multiple, value) => ({
  type: 'TOGGLE',
  multiple,
  value
})
